import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { useTooltip } from '@frontend/design-system';

type Props = {
  label: string;
  children: ReactNode;
};

export const LabelledIcon = ({ label, children }: Props) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({
    placement: 'top',
  });

  return (
    <span
      css={css`
        position: relative;
      `}
      {...triggerProps}
    >
      {children}
      <Tooltip {...tooltipProps}>{label}</Tooltip>
    </span>
  );
};
